import { client } from '@/common-utils/libraries/axios/axios';
import { TERMINAL_CONTRACTS } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationUpdateContractLabel2 = (onSuccess, onError) => {
    return {
        mutationFn: ({ contractId, application, label }) => {
            return client.put(
                replaceParameters(TERMINAL_CONTRACTS.DETAILS.url, { merchantContractId: contractId }),
                { label: label, application: application, uuid: contractId }
            );
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateContractLabel2;